import React, { useContext } from 'react'
import { TranslateContext } from '../../../../../common/translator'
import { Flex, Link, CrossIcon, Box } from 'chemistry'
import { useSelector } from 'react-redux'
import { getLabel } from '../utilsFilters'
import { BRICO } from 'client/common/utils'
import { dictionary } from 'client/common/accessability'

export const ActiveFiltersTop = ({ activeFilters, onRemove, onClear }) => {
  const showNewFilterLabels = useSelector(({ data }) => data?.flags?.showNewFilterLabels)
  const format = useSelector(({ data }) => data?.format)
  const lang = useSelector(({ data }) => data?.lang)
  const t = useContext(TranslateContext)
  if (!activeFilters || !Object.keys(activeFilters).length) return null
  return (
    <Flex width='100%' gap='16px' mt='16px' pb='24px' flexWrap='wrap'>
      {Object.entries(activeFilters).map(([key, values]) =>
        values.map(value => {
          const text = format === BRICO && showNewFilterLabels ? getLabel(value.label) : value.label

          return (
            <Box
              fontSize='14px'
              lineHeight='21px'
              borderRadius='8px'
              letterSpacing='0.25px'
              d='flex'
              gap='4px'
              alignItems='center'
              variant='tertiary'
              h='40px'
              py='6px'
              pl='8px'
              pr='12px'
              color='grey.900'
              background='white'
              border='1px solid'
              borderColor='black'
              key={`${value.label}`}
              cursor='default'
              _hover={{ background: 'grey.300' }}
            >
              <button
                title={`${dictionary(lang).removeX} ${text}`}
                onClick={() => {
                  onRemove({
                    title: key,
                    item: {
                      checked: false,
                      value
                    },
                    filterPosition: 'top'
                  })
                }}
              >
                <CrossIcon />
              </button>
              {text}
            </Box>
          )
        })
      )}
      <Link as='button' onClick={onClear}>
        {t('lister.filters.clear_filters')}
      </Link>
    </Flex>
  )
}
